export default __webpack_public_path__ + "static/media/8.2f63a3f4.jpg";